import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartBubble"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V1.5H3V21H22.5V22.5ZM11.25 7.5C11.25 5.01472 13.2647 3 15.75 3C18.2353 3 20.25 5.01472 20.25 7.5C20.25 9.98528 18.2353 12 15.75 12C13.2647 12 11.25 9.98528 11.25 7.5ZM15.75 4.5C17.4069 4.5 18.75 5.84315 18.75 7.5C18.75 9.15685 17.4069 10.5 15.75 10.5C14.0931 10.5 12.75 9.15685 12.75 7.5C12.75 5.84315 14.0931 4.5 15.75 4.5ZM4.5 13.5C4.5 11.8431 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 11.8431 10.5 13.5C10.5 15.1569 9.15685 16.5 7.5 16.5C5.84315 16.5 4.5 15.1569 4.5 13.5ZM9 13.5C9 12.6716 8.32843 12 7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15C8.32843 15 9 14.3284 9 13.5ZM18.375 15.75C18.9963 15.75 19.5 16.2537 19.5 16.875C19.5 17.4963 18.9963 18 18.375 18C17.7537 18 17.25 17.4963 17.25 16.875C17.25 16.2537 17.7537 15.75 18.375 15.75ZM15.75 16.875C15.75 15.4253 16.9253 14.25 18.375 14.25C19.8247 14.25 21 15.4253 21 16.875C21 18.3247 19.8247 19.5 18.375 19.5C16.9253 19.5 15.75 18.3247 15.75 16.875Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartBubble.vue"]]);
